import type { ReactNode } from 'react'

import { useAuth } from 'src/auth'
import { openSupportHome } from 'src/components/ApplicationAssistant/useAssistantSideEffects'
import { Button, HeadsetIcon, Icon } from 'src/design-system/ui'
import { ProfessionalTopBar } from 'src/layouts/_shared/ProfessionalTopBar'
import type { UiColorMode } from 'src/design-system/ui/themes'

import '../_shared/professional-shell.css'

/** Portal-specific support action on the shared Professional top bar. */
export const BusinessPortalTopBar = ({
  leadingContent,
  mode,
  chooseMode,
}: {
  leadingContent: ReactNode
  mode: UiColorMode
  chooseMode: (mode: UiColorMode) => void
}) => {
  const { isAuthenticated } = useAuth()
  return (
    <ProfessionalTopBar
      leadingContent={leadingContent}
      mode={mode}
      chooseMode={chooseMode}
      actions={
        isAuthenticated ? (
          <Button
            variant="secondary"
            size="compact"
            leadingIcon={<Icon icon={HeadsetIcon} size="sm" />}
            onPress={openSupportHome}
          >
            Support
          </Button>
        ) : null
      }
    />
  )
}
